/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // BAIKIS: Slider imágenes
  function baikisSlide(btn, dir) {
    var wrapper = btn.closest('[data-product-image]');
    var raw = wrapper.getAttribute('data-baikis-images');
    if (!raw) return;
    var images = raw.split(',').map(function(s){ return s.trim(); }).filter(Boolean);
    if (images.length <= 1) return;

    var idx = parseInt(wrapper.getAttribute('data-slider-index')) || 0;
    idx = (idx + dir + images.length) % images.length;
    wrapper.setAttribute('data-slider-index', idx);

    // Crear o reutilizar una imagen de overlay
    var overlay = wrapper.querySelector('.baikis-img-overlay');
    if (!overlay) {
      overlay = document.createElement('img');
      overlay.className = 'baikis-img-overlay';
      overlay.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;z-index:4;';
      wrapper.querySelector('[data-product-image-default]').appendChild(overlay);
    }

    overlay.src = images[idx];
    overlay.style.display = 'block';

    // Resetear cuando el ratón salga del producto
    var card = wrapper.closest('[data-grid-item]');
    if (card && !card._baikisResetSet) {
      card._baikisResetSet = true;
      card.addEventListener('mouseleave', function() {
        if (overlay) overlay.style.display = 'none';
        wrapper.setAttribute('data-slider-index', '0');
        card._baikisResetSet = false;
      });
    }
  }
  window.baikisSlide = baikisSlide;

  // BAIKIS: Añadir al carrito
  function baikisAddToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.classList.contains('size-badge--adding')) return;
    btn.classList.add('size-badge--adding');
    var originalText = btn.textContent;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.classList.remove('size-badge--adding');
      btn.classList.add('size-badge--added');
      btn.textContent = '✓';

      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            bubbles: true,
            detail: { cartCount: cart.item_count }
          }));
          var drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
        });

      setTimeout(function() {
        btn.classList.remove('size-badge--added');
        btn.textContent = originalText;
      }, 1500);
    })
    .catch(function() {
      btn.classList.remove('size-badge--adding');
      btn.textContent = originalText;
    });
  }
  window.baikisAddToCart = baikisAddToCart;

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();